import { Map, Marker, useMap } from '@vis.gl/react-google-maps';
import { useState, useRef, useCallback, useImperativeHandle, useEffect } from 'react';

import Modal from '@Components/Shared/Modals/Modal';

const CharterMapModal = (props) => {
    const [flightPaths, setFlightPaths] = useState([]);
    const cameraChangeTimeout = useRef(null);
    const map = useMap();
    const mapBoundsLoaded = useRef(false);

    const onClose = () => {
        props.toggleModal();
    };

    const handleCameraChange = useCallback((ev) => {
        if (cameraChangeTimeout.current) {
            clearTimeout(cameraChangeTimeout.current);
        }

        if (mapBoundsLoaded.current) {
            cameraChangeTimeout.current = setTimeout(() => {
                props.onLocationChange(ev.detail.bounds);
            }, 1000);
        }
        mapBoundsLoaded.current = true;
    }, [props.onLocationChange]);

    useEffect(() => {
        if (props.flightPaths && map) {
            // Remove existing flight paths from the map
            flightPaths.forEach(flightPath => flightPath.setMap(null));

            var arrowSymbol = {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                strokeColor: '#FF0000',
            };

            const newFlightPaths = props.flightPaths.map(path => {
                var line = [
                    { lat: path.From.Latitude, lng: path.From.Longitude },
                    { lat: path.To.Latitude, lng: path.To.Longitude }
                ];

                const flightPath = new google.maps.Polyline({
                    path: line,
                    icons: [{
                        icon: arrowSymbol,
                        scale: 5,
                        strokeColor: "#FF0000",
                        offset: '50%'
                    }],
                    geodesic: true,
                    strokeColor: "#FF0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                });
                flightPath.setMap(map);
                return flightPath;
            });

            // Update state with new flight paths
            setFlightPaths(newFlightPaths);
        }
    }, [props.flightPaths, map]);

    return (
        <Modal contentClassName='map-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose} />
            <Modal.Body>
                <Map
                    defaultCenter={props.defaultCenter ? { lat: props.defaultCenter.Latitude, lng: props.defaultCenter.Longitude } : { lat: 40.8058, lng: -96.6718 }}
                    defaultZoom={props.defaultZoom ? props.defaultZoom : 2}
                    onCameraChanged={handleCameraChange}
                >
                    {props.locations?.map((location, i) => (
                        <Marker
                            key={i}
                            position={{ lat: location.Latitude, lng: location.Longitude }}
                        />
                    ))}
                </Map>
            </Modal.Body>
        </Modal>
    );
};

export default CharterMapModal;